import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from '@routingModule';
import { SharedModule } from '../../../shared/shared.module';
import { MaterialModule } from '@modules/material.module';
import { PrimengModule } from '@modules/primeng.module';
import { AccordionModule } from 'primeng/accordion';

import { EditarModeloVistoriaComponent } from './components/editar-modelo-vistoria.component';
import { ItensModeloVistoriaComponent } from './components/itens-modelo-vistoria/itens-modelo-vistoria.component';
import { ComodosModeloVistoriaComponent } from './components/comodos-modelo-vistoria/comodos-modelo-vistoria.component';
import { EditarModeloVistoriaResolver } from './editar-modelo-vistoria.resolver';

@NgModule({
  declarations: [
    EditarModeloVistoriaComponent,
    ItensModeloVistoriaComponent,
    ComodosModeloVistoriaComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    SharedModule,
    MaterialModule,
    PrimengModule,
    AccordionModule,
  ],
  providers: [
    EditarModeloVistoriaResolver,
  ],
})
export class EditarModeloVistoriaModule { }
